<div class="modern-menu-container">
  @if (menuReady) {
  <div
    class="modern-sidebar"
    [class.collapsed]="!isMobile && menuCollapsed"
    [class.is-width-animating]="!isMobile && isMenuWidthAnimating"
    [class.mobile-open]="isMobile && isOpen"
  >
    @if (!isMobile) {
    <button
      class="toggle-btn-external"
      (click)="toggleMenuCollapse()"
      [attr.aria-label]="menuCollapsed ? 'Expand menu' : 'Collapse menu'"
      [attr.aria-expanded]="!menuCollapsed"
    >
      <mat-icon
        class="toggle-btn-icon"
        [style.transform]="'rotate(' + menuToggleIconTurns * 180 + 'deg)'"
        >arrow_left</mat-icon
      >
    </button>
    }

    <div class="sidebar-clip">
      <div class="menu-search-section">
        <enr-input
          [leadingIcon]="true"
          placeholder="Search menu..."
          size="small"
          [value]="searchTerm"
          (valueChange)="onSearchChange($event)"
        >
          <svg
            slot="leading-icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </enr-input>
      </div>

      <div class="navigation py-2 px-1">
        <app-side-nav
          class="main-menu-side-nav block h-full min-h-0 w-full"
          [collapsed]="!isMobile && menuCollapsed"
          [items]="sideNavItems"
          [pinnedItems]="dashboardPinnedItems"
          [activePath]="activeMenuPath || currentUrlPath"
          [allowCollapseActiveAncestors]="true"
          (itemSelect)="onSideNavItemSelect($event)"
          (collapsedChange)="onSideNavCollapsedChange($event)"
        />
      </div>
    </div>
  </div>
  }
</div>
